import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/',
      redirect: '/login'
    },

    {
      path: '/login',
      name: 'login',
      component: (resolve) => require(['../pages/login/login'], resolve),
    },
    {
      path: '/home',
      name: 'home',
      component: (resolve) => require(['../pages/home/home'], resolve),
    },
    {
      path: '/orderStatistics',
      name: 'orderStatistics',
      component: (resolve) => require(['../pages/orderStatistics/orderStatistics'], resolve),
    },
    {
      path: '/deviceStatus',
      name: 'deviceStatus',
      component: (resolve) => require(['../pages/deviceStatus/deviceStatus'], resolve)
    },
     {
      path: '/deviceFault',
      name: 'deviceFault',
      component: (resolve) => require(['../pages/deviceFault/deviceFault'], resolve)
    },
     {
      path: '/finance',
      name: 'finance',
      component: (resolve) => require(['../pages/finance/finance'], resolve)
    },
     {
      path: '/purchase',
      name: 'purchase',
      component: (resolve) => require(['../pages/purchase/purchase'], resolve)
    },
     {
      path: '/sale',
      name: 'sale',
      component: (resolve) => require(['../pages/sale/sale'], resolve)
    }

  ]
})



//////////////////
// WEBPACK FOOTER
// ./src/router/index.js
// module id = null
// module chunks = 